export function formatBookName(bookName) {
  if (bookName.endsWith("#")) {
    return bookName.substring(0, bookName.length - 1).trim();
  } else {
    return bookName;
  }
}
